import React from 'react';
import TaskSectionPage from '../components/TaskSectionPage';

const Reading: React.FC = () => {
  return (
    <TaskSectionPage
      section="reading"
      title="Reading"
      description="Improve your reading comprehension with engaging texts and exercises."
    />
  );
};

export default Reading;